import { REHYDRATE } from 'redux-persist';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';
import { isSavedFilters } from '~utils/filters';
import omit from 'lodash/omit';
import * as userActions from './actions';

const initialState = {
    id: '',
    email: '',
    username: '',
    first_name: '',
    last_name: '',
    full_name: '',
    role: '',
    group_name: '',
    settings: null,
    feed_settings: null,
    paid_level: '',
    phone: '',
    position: '',
    photo: '',
    lawsAllPublicationsSavedFilters: null,
    lawsMyFavoritesSavedFilters: null,
    lawsMyActionsSavedFilters: null,
    lawsWaitingSavedFilters: null,
    isSavedAllPublicationFilters: false,
    isSavedMyFavoritesFilters: false,
    isSavedMyActionsFilters: false,
    isSavedWaitingFilters: false,
    isUserFetching: false,
    isAllPublicationFiltersSaving: false,
    isMyFavoritesFiltersSaving: false,
    isMyActionsFiltersSaving: false,
    isWaitingFiltersSaving: false,
    ut: '',
    newsUser: {
        id: '',
        token: null,
        token_expires_at: null,
    },
    lawsUser: {
        id: '',
        token: null,
        token_expires_at: null,
    },
    blocked: false,
    group: {
        ecosystem_functions: null,
        company: {
            name: '',
            project_passport_title: '',
            ecosystem_events_title: '',
        }
    },
    ecosystem: { 
        functions: null, 
        company: null,
        listFunctions: null,
        listSubdivisions: null,
    },
    // theme: {
    //     primaryColor: '#3377bb',
    //     primaryDisabledColor: '#99bbdd',
    //     secondaryColor: '',
    //     font: '',
    // },
};

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case userActions.SET_USER_FETCHING:
            return {
                ...state,
                isUserFetching: action.isFetching,
            };

        case userActions.LOGIN:
            let newState = {
                ...initialState,
                ...omit(action.user, [
                    'id',
                    'all_publications_feed_saved_filters',
                    'my_favorites_feed_saved_filters',
                    'my_actions_feed_saved_filters',
                    'waiting_feed_saved_filters',
                ]),
            };
            newState.newsUser.token_expires_at = Date.parse(newState.newsUser.token_expires_at);
            newState.lawsUser.token_expires_at = Date.parse(newState.lawsUser.token_expires_at);

            const lawsAllPublicationsSavedFilters = action.user.all_publications_feed_saved_filters;
            const lawsMyFavoritesSavedFilters = action.user.my_favorites_feed_saved_filters;
            const lawsMyActionsSavedFilters = action.user.my_actions_feed_saved_filters;
            const lawsWaitingSavedFilters = action.user.waiting_feed_saved_filters;

            newState.lawsAllPublicationsSavedFilters = isSavedFilters(lawsAllPublicationsSavedFilters)
                ? lawsAllPublicationsSavedFilters
                : null;
            newState.lawsMyFavoritesSavedFilters = isSavedFilters(lawsMyFavoritesSavedFilters)
                ? lawsMyFavoritesSavedFilters
                : null;
            newState.lawsMyActionsSavedFilters = isSavedFilters(lawsMyActionsSavedFilters)
                ? lawsMyActionsSavedFilters
                : null;
            newState.lawsWaitingSavedFilters = isSavedFilters(lawsWaitingSavedFilters) ? lawsWaitingSavedFilters : null;

            newState.isSavedAllPublicationFilters = isSavedFilters(lawsAllPublicationsSavedFilters) ? true : false;
            newState.isSavedMyFavoritesFilters = isSavedFilters(lawsMyFavoritesSavedFilters) ? true : false;
            newState.isSavedMyActionsFilters = isSavedFilters(lawsMyActionsSavedFilters) ? true : false;
            newState.isSavedWaitingFilters = isSavedFilters(lawsWaitingSavedFilters) ? true : false;
            return newState;

        case userActions.UPDATE_USER:
            return {
                ...state,
                ...action.userData,
                isUserFetching: false,
            };

        // ALL PUBLICATIONS PAGE
        case userActions.SAVE_LAWS_ALL_PUB_USER_FILTERS:
            return {
                ...state,
                lawsAllPublicationsSavedFilters: action.filters,
                isSavedAllPublicationFilters: true,
                isAllPublicationFiltersSaving: false,
            };

        case userActions.SET_LAWS_ALL_PUB_USER_FILTERS_SAVING:
            return {
                ...state,
                isAllPublicationFiltersSaving: action.isFiltersSaving,
            };

        case userActions.DELETE_LAWS_ALL_PUB_USER_FILTERS:
            return {
                ...state,
                lawsAllPublicationsSavedFilters: null,
                isSavedAllPublicationFilters: false,
                isAllPublicationFiltersSaving: false,
            };

        // MY FAVORITES PAGE
        case userActions.SAVE_LAWS_MY_FAV_USER_FILTERS:
            return {
                ...state,
                lawsMyFavoritesSavedFilters: action.filters,
                isSavedMyFavoritesFilters: true,
                isMyFavoritesFiltersSaving: false,
            };

        case userActions.SET_LAWS_MY_FAV_USER_FILTERS_SAVING:
            return {
                ...state,
                isMyFavoritesFiltersSaving: action.isFiltersSaving,
            };

        case userActions.DELETE_LAWS_MY_FAV_USER_FILTERS:
            return {
                ...state,
                lawsMyFavoritesSavedFilters: null,
                isSavedMyFavoritesFilters: false,
                isMyFavoritesFiltersSaving: false,
            };

        // MY ACTIONS PAGE
        case userActions.SAVE_LAWS_MY_ACTIONS_USER_FILTERS:
            return {
                ...state,
                lawsMyActionsSavedFilters: action.filters,
                isSavedMyActionsFilters: true,
                isMyActionsFiltersSaving: false,
            };

        case userActions.SET_LAWS_MY_ACTIONS_USER_FILTERS_SAVING:
            return {
                ...state,
                isMyActionsFiltersSaving: action.isFiltersSaving,
            };

        case userActions.DELETE_LAWS_MY_ACTIONS_USER_FILTERS:
            return {
                ...state,
                lawsMyActionsSavedFilters: null,
                isSavedMyActionsFilters: false,
                isMyActionsFiltersSaving: false,
            };

        // WAITING PAGE
        case userActions.SAVE_LAWS_WAITING_USER_FILTERS:
            return {
                ...state,
                lawsWaitingSavedFilters: action.filters,
                isSavedWaitingFilters: true,
                isWaitingFiltersSaving: false,
            };

        case userActions.SET_LAWS_WAITING_USER_FILTERS_SAVING:
            return {
                ...state,
                isWaitingFiltersSaving: action.isFiltersSaving,
            };

        case userActions.DELETE_LAWS_WAITING_USER_FILTERS:
            return {
                ...state,
                lawsWaitingSavedFilters: null,
                isSavedWaitingFilters: false,
                isWaitingFiltersSaving: false,
            };

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.CHANGE_THEME:
            return {
                ...state,
                theme: action.theme,
            };

        case REHYDRATE:
            const savedUser = action.payload && action.payload.user;
            return {
                ...state,
                ...savedUser,
                isUserFetching: false,
            };

        // case REHYDRATE:
        //     if (action.payload) {
        //         const savedAllPublicationFilters = action.payload.user ? action.payload.user.lawsAllPublicationsSavedFilters : {};
        //         return {
        //             ...action.payload.user,
        //             isSavedFilters: !isEmptyObj(savedUserFilters)
        //         };
        //     }
        //     return initialState;

        default:
            return state;
    }
};

export default initialState;



// WEBPACK FOOTER //
// ./src/redux_related/user/reducer.js